/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:900px){aside[_ngcontent-%COMP%]{align-items:center;justify-content:center}}"];
export { styles as styles };
